import React from 'react';
import browsers_icon from '../../../assets/browsers.png';

interface IProps {
  onSubmit(email: string): void;
  error?: string;
}

interface IState {
  email: string;
}

export class HomeBanner extends React.Component<IProps, IState> {
  handleChange(e: React.ChangeEvent<HTMLInputElement>) {
    this.setState({
      email: e.target.value
    });
  }

  handleSubmit() {
    this.props.onSubmit(this.state.email);
  }

  render() {
    return (
      <div id="home_wrapper">
        <div className="container">
          <div className="row">
            <div className="col-md-12 text-center padding-top-80">
              <h1 className="home-title">iSlide Premium Giveaway For GOTD</h1>
              <p className="home-subtitle">
                The Best PowerPoint Add-in Ever <br />
                Save 90% time in presentation design
              </p>
              <div className="newsletter-form">
                <div>
                  <input
                    className="email-newsletter"
                    placeholder="Enter Your Email Address"
                    onChange={this.handleChange.bind(this)}
                  />
                  <button
                    className="email-btn"
                    onClick={this.handleSubmit.bind(this)}
                  >
                    GET IT NOW
                  </button>
                </div>
                {this.props.error ? (
                  <p className="error">{this.props.error}</p>
                ) : null}
                <img
                  className="padding-top-50"
                  style={{ width: '100%' }}
                  src={browsers_icon}
                  alt="browers"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
